/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../impl/SmartsRecommenderFeature',
	'./api/SmartsRecommenderAPI',
	'./api/DeprecatedSmartsRecommenderAPI'
], function (APIFactory, SmartsRecommenderFeature, SmartsRecommenderAPI, DeprecatedSmartsRecommenderAPI) {
	'use strict';

	class VisualizationSmartsRecommender extends SmartsRecommenderFeature {

		constructor(options) {
			super(options);
			this._api = APIFactory.createAPI(this, [SmartsRecommenderAPI]);
			this._deprecatedAPI = APIFactory.createAPI(this, [DeprecatedSmartsRecommenderAPI]);
		}

		destroy() {
			super.destroy();
			this._api = null;
			this._deprecatedAPI = null;
		}

		getAPI(type) {
			if (type === 'deprecated'){
				return this._deprecatedAPI;
			}

			return this._api;
		}

		recommendAlternateContent() {
			throw new Error('Not implemented yet');
		}

		recommendRelatedContent() {
			throw new Error('Not implemented yet');
		}

		recommendAlternateVisualizationsAsWidgetSpecs(dataSourceId, columnIds) {
			return super.recommendAlternateVisualizationsFromColumnIds(dataSourceId, columnIds)
				.then(recommendations => this._transformToWidgetSpecs(recommendations, dataSourceId));
		}

		// deprecated interface -- called by explore
		recommendRelatedVisualizationsAsWidgetSpecs(dataSourceId, columnIds, includeBestVisForTargetFields) {
			return super.recommendRelatedVisualizationsFromColumnIds(dataSourceId, columnIds, null, includeBestVisForTargetFields)
				.then(recommendations => this._transformToWidgetSpecs(recommendations, dataSourceId));
		}

		transformRecommendationsToLiveWidgetSpecs(recommendations, sourceId) {
			let transformedRecommendations = this._visRecommenderDelegator.smarts._transformRecommendationResponse(sourceId, recommendations);
			return  this._transformToWidgetSpecs(transformedRecommendations, sourceId);
		}

		_transformToWidgetSpecs(recommendations, sourceId){
			return this._transformWidgetRecommendationsToLiveWidgetSpecs(recommendations, {
				type: 'live',
				data:{
					dataViews: [{
						id: 'id_123',
						modelRef: sourceId
					}]
				}
			});
		}
	}

	return VisualizationSmartsRecommender;
});
